import React from 'react'

import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import Image from 'components/Common/Image'
import styled from 'styled-components'

const CarouselImage = styled(Image)`
  border-radius: ${({ theme }) => theme.borderRadius.S};
`

interface Props {
  images: Array<App.Image>
}

function ItemCardImageCarousel({ images }: Props) {
  return (
    <CardCarousel gap={8} snap="start" gutterSize={20}>
      {images.map((image, i) => (
        <CarouselImage key={i} image={image} width={160} height={104} highRes loading="lazy" />
      ))}
    </CardCarousel>
  )
}

export default ItemCardImageCarousel
